import { gql } from "@apollo/client";
import { AccountFragment } from "fragments/account";

// No keySecret. The API stores a bcrypt hash and only returns a usable value
// from create, so asking for it on a read selects a field that is always null
// and advertises an interest in a credential this app cannot use. `create`
// below adds it back inline — the same split auth-repoflow's app makes.
export const KeyFragment = gql`
  fragment KeyFragment on Key {
    id
    keyId
    description
    roles
    scope {
      service
      type
      id
    }
    siteId

    createdAt
    updatedAt
  }
`;

export const get = gql`
  query KeyGet($keyId: String!) {
    viewer {
      id
      account {
        ...AccountFragment
        keys {
          id
          get(keyId: $keyId) {
            ...KeyFragment
          }
        }
      }
    }
  }
  ${AccountFragment}
  ${KeyFragment}
`;

export const list = gql`
  query KeyList($input: ListInput) {
    viewer {
      id
      account {
        id
        keys {
          id
          list(input: $input) {
            id
            last
            items {
              ...KeyFragment
            }
          }
        }
      }
    }
  }
  ${KeyFragment}
`;




// The agent keys bound to one site — the site's "Agents" screen. A read of the
// org's key rows walked and filtered by the API (model/key.agents), because
// auth-repoflow pages keys five at a time and cannot filter by site.
export const agents = gql`
  query KeyAgents($siteId: String!) {
    viewer {
      id
      account {
        id
        keys {
          id
          agents(siteId: $siteId) {
            id
            siteId
            complete
            items {
              ...KeyFragment
            }
          }
        }
      }
    }
  }
  ${KeyFragment}
`;

export const create = gql`
  mutation KeyNew($input: KeyInputCreate!) {
    viewer {
      account {
        keys {
          create(input: $input) {
            keySecret
            ...KeyFragment
          }
        }
      }
    }
  }
  ${KeyFragment}
`;




export const remove = gql`
  mutation KeyRemove($keyId: String!) {
    viewer {
      account {
        keys {
          get(keyId: $keyId) {
            remove 
          }
        }
      }
    }
  }

`;




export const update = ({ keyId }) => (cache) => {

  Object.keys(cache.data.data).forEach((key) => {
    if (key.includes(`keys/queries`)) {
      cache.data.delete(key);
    }
  });
};
